import React from 'react'
import { Box } from '@workwhile/ui'
import { IndeedFlexAuthStatusBanner } from 'pages/IndeedFlex/shared/components/IndeedFlexAuthStatusBanner'
import { IndeedFlexIssuesFilterBar } from './IndeedFlexIssuesFilterBar'
import { IndeedFlexShiftIssuesHeader } from './IndeedFlexShiftIssuesHeader'
import { IndeedFlexShiftIssuesTable } from './IndeedFlexShiftIssuesTable'

export const IndeedFlexShiftIssuesMain = () => {
  return (
    <>
      <IndeedFlexShiftIssuesHeader />
      <IndeedFlexAuthStatusBanner />
      <IndeedFlexIssuesFilterBar />
      <Box margin={3}>
        <IndeedFlexShiftIssuesTable />
      </Box>
    </>
  )
}
